import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const CartDeleteResponseSchema = z.object({
  data: z.string(),
});

export const CartResponseSchema = z
  .object({
    data: z.object({
      cart_id: z.number(),
      total_cost_price: z.number(),
      total_costs: z.number(),
      cart_items: z
        .array(
          z.object({
            product_id: z.number(),
            name: z.string(),
            price: z.number(),
            quantity: z.number(),
            max_quantity: z.number(),
            is_trial: z.boolean(),
          }),
        )
        .default([]),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TCartResponse = z.infer<typeof CartResponseSchema>;
export type TCartResponseData = TCartResponse['data'];
export type TCartItem = TCartResponseData['cartItems'][0];
